import React from "react";
import { getScriptSrc } from "@qlik/qlik/src/lib/util/helpers";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { Script } from "gatsby";
import Loader from "@qlik/qlik/src/assets/images/spinner.gif";
import * as styles from "./styles.module.css";

const FindPartnerCustomScript = ({ data }) => {
    const { cardItem, additionalConfiguration, customId } = data ?? {};
    const { body } = cardItem ?? {};

    const sectionPaddingClassName = getSpacingClassName(additionalConfiguration);
    const src = getScriptSrc(body?.raw);

    return (
        <section className={`${styles.partnerForm} pb-0 lg:pb-12.5 ${sectionPaddingClassName}`} id={customId}>
            <div className="container p-0 xl:px-4.75 min-h-[395px] md:min-h-60.75 relative">
                <Script src={src} />
                <div className={`${styles.formSection}`} id="zl_realLocatorContainer">
                    <div
                        className={`${styles.customLoader} min-h-[395px] md:min-h-60.75 flex items-center justify-center`}
                    >
                        <img src={Loader} alt="Loader" />
                    </div>
                </div>
            </div>
        </section>
    );
};
export default FindPartnerCustomScript;
